import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { usePrevious } from './usePrevious';
import { setQuoteId } from '../actions';

export const useQuoteIdTracker = () => {
  const quoteId = useSelector(
    ({ quoting }) => quoting.saveQuote.quoteId,
    shallowEqual,
  );
  const dispatch = useDispatch();

  const prevQuoteId = usePrevious(quoteId);
  useEffect(() => {
    if (prevQuoteId !== quoteId && !quoteId && prevQuoteId) {
      // FIX: This is a patch to recover the quoteId since the Defect 212088
      // was unable to replicate but in prod still happening
      // without an identificable interaction pattern.
      dispatch(setQuoteId(prevQuoteId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteId]);
};
